import React from 'react';

import {
  Datagrid,
  List as RaList,
  Pagination,
  TextField,
  useListContext,
  useQueryWithStore,
  useTranslate,
} from 'react-admin';

import {
  LinearProgress,
  makeStyles,
} from '@material-ui/core';

import { DATE_RANGE_EXPR } from '../components/inputs/DateRangeInput';
import { useDatagridStyles } from '../components/lists/useStyles';
import EventField from '../stats/fields/EventField';
import perPage from '../utils/per-page';
import Filters from './Filters';

const useListStyles = makeStyles(
	(theme) => ({
		// rowEven: { backgroundColor: red[500] },
		main: {
			"& table td, table th": {
				whiteSpace: "nowrap",
			},
		},
		[theme.breakpoints.down("sm")]: {
			main: (props) => ({
				maxWidth: "100vw",
				overflowX: "auto",
				marginTop: "1em",
			}),
			content: {
				boxShadow: "none",
			},
		},
	}),
	{ name: "RaStatsList" }
);

const DesktopList = ({ permissions, events, ...props }) => {
	const classes = useDatagridStyles();
	const { filterValues } = useListContext();
	const translate = useTranslate();

	return (
		<Datagrid {...props} classes={classes}>
			<TextField source="subid" style={{ fontWeight: "bold", width: "10%" }} />
			{filterValues?.group_by?.includes("user_id") && (
				<TextField source="user" label={translate("resources.users.name", 1)} />
			)}
			{filterValues?.group_by?.includes("bookmaker_id") && (
				<TextField
					source="bookmaker"
					label={translate("resources.bookmakers.name", 1)}
				/>
			)}
			{filterValues?.group_by?.includes("bookmaker_channel_id") && (
				<TextField
					source="bookmaker_channel"
					label={translate("resources.stats.fields.channel", 1)}
				/>
			)}
			{events.map((event) => (
				<EventField key={event.id} source={event.name} event={event} />
			))}
		</Datagrid>
	);
};

const List = (props) => {
	const today = DATE_RANGE_EXPR.today();
	const { data } = useQueryWithStore({
		type: "getList",
		resource: "events",
		payload: {
			sort: { field: "order", order: "ASC" },
			pagination: {
				page: 1,
				perPage: 100,
			},
			filter: {
				user: true,
			},
		},
	});
	const classes = useListStyles();
	const { permissions } = props;
	if (typeof permissions !== "function") {
		return <LinearProgress />;
	}

	return (
		<RaList
			{...props}
			classes={classes}
			perPage={perPage(50, 100)}
			filters={<Filters permissions={props.permissions || ((role) => false)} />}
			pagination={
				<Pagination
					rowsPerPageOptions={[10, 25, 50, 100, 200, 250, 500, 1000]}
				/>
			}
			bulkActionButtons={false}
			sort={{
				field: "qualified",
				order: "DESC",
			}}
			filterDefaultValues={{
				view: "today",
				start_at: today.start_at,
				end_at: today.end_at,
			}}
			title="resources.dynamic-variables-stats.name"
			exporter={false}
		>
			<DesktopList
				events={
					data
						? data.filter(
								(e) =>
									(permissions && permissions("user") && e.code !== "REV") ||
									(permissions && permissions("admin"))
						  )
						: []
				}
				permissions={props.permissions || ((role) => false)}
			/>
		</RaList>
	);
};
export default List;
